import { FunctionComponent } from 'react';
import mainLogo from '../../assets/logoWhite.png';

const HELP_LINKS = [
    { href: 'https://icelandair.atlassian.net/wiki/spaces/MCP/pages/140017892/Maintener', label: 'Help' },
    { href: 'https://icelandair.atlassian.net/servicedesk/customer/portal/1/group/33', label: 'Contact' },
    { href: 'https://icelandair.atlassian.net/wiki/spaces/MCP/pages/446791687/Release+Notes', label: 'Releases' },
    { href: 'https://icelandair.atlassian.net/wiki/spaces/MCP/pages/448036874/FAQs', label: 'FAQ' },
];

/**
 * The wordmark + help links band, rendered only on Hangar Overview.
 *
 * It lives inside the content column rather than above the sidebar, so the
 * sidebar's box is identical on every route - putting it above would shift the
 * one element that survives navigation every time you enter or leave this page.
 *
 * The logo is decorative here: it used to navigate to Hangar Overview, which is
 * the only route this band renders on. The sidebar footer carries the
 * persistent home affordance instead.
 */
const HangarHeader: FunctionComponent = () => (
    <header
        className="ds-header flex-none justify-between"
        id="header"
    >
        <img className="ds-header-logo w-32" src={mainLogo} alt="Icelandair Maintener" />
        <nav className="hidden items-center gap-5 sm:flex">
            {HELP_LINKS.map(link => (
                <a
                    key={link.label}
                    href={link.href}
                    target="_blank"
                    rel="noreferrer"
                    className="text-[length:var(--ds-fs-sm)] text-[color:var(--ds-header-fg)] no-underline hover:underline"
                >
                    {link.label}
                </a>
            ))}
        </nav>
    </header>
);

export default HangarHeader;
